<main class="page-container">
  <div class="top-space" aria-label="Home icon">
    <!-- Home icon as SVG inline -->
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <path
        fill="#444"
        d="M8 1.4l-2 1.3v-1.7h-2v3l-4 2.6 0.6 0.8 7.4-4.8 7.4 4.8 0.6-0.8z"
      ></path>
      <path fill="#444" d="M8 4l-6 4v7h5v-3h2v3h5v-7z"></path>
    </svg>
  </div>

  <div class="bottom-space">
    <div id="paypal" class="buttons-container">
      <a class="btn" routerLink="/paypal">Paypal Payment Receipt</a>
    </div>

    <div id="card" class="buttons-container">
      <a class="btn" routerLink="/card">Card Payment Receipt</a>
    </div>

    <div id="account" class="buttons-container">
      <a class="btn" routerLink="/account">Account Payment Receipt</a>
    </div>

    <div id="return" class="buttons-container">
      <a class="btn" routerLink="/return">Return Payment</a>
    </div>
  </div>
</main>
